import { isRedoEmailAddress } from "@redotech/account-common/redo-domains";
import { isWelcomeRoute } from "../../../onboarding/first-install-redirect";
import { isRoleStepRequired } from "../../../welcome/welcome-flow";
import { isWmsRoute } from "../../wms-route";

export const JOB_LEVEL_BACKFILL_DELAY_MS = 20 * 60 * 1000;

export interface JobLevelBackfillUser {
  createdAt?: string;
  email: string;
  jobProfile?: { job?: readonly string[] | null; level?: string | null };
}

export function shouldShowJobLevelBackfillPrompt(args: {
  firstInstallOnboardingPending?: boolean;
  isAdminImpersonation?: boolean;
  user: JobLevelBackfillUser | null | undefined;
  pathname: string;
  now: number;
}): boolean {
  const {
    firstInstallOnboardingPending,
    isAdminImpersonation,
    user,
    pathname,
    now,
  } = args;
  if (
    !user ||
    firstInstallOnboardingPending ||
    isWelcomeRoute(pathname) ||
    isWmsRoute(pathname)
  ) {
    return false;
  }
  if (isAdminImpersonation || isRedoEmailAddress(user.email)) {
    return false;
  }
  const availableAt = jobLevelBackfillAvailableAt(user);
  if (availableAt !== undefined && now < availableAt) {
    return false;
  }
  return isRoleStepRequired(user.jobProfile);
}

/**
 * New users get time in the product before the required role prompt blocks the
 * screen, so it waits until JOB_LEVEL_BACKFILL_DELAY_MS after signup.
 */
export function jobLevelBackfillAvailableAt(
  user: JobLevelBackfillUser | null | undefined,
): number | undefined {
  if (!user?.createdAt) {
    return undefined;
  }
  const createdAt = Date.parse(user.createdAt);
  return Number.isNaN(createdAt)
    ? undefined
    : createdAt + JOB_LEVEL_BACKFILL_DELAY_MS;
}
